import BookingServicePackagesListTable from "@/components/LastMinute/BookingServicePackagesListTable/BookingServicePackagesListTable.vue";
import { debounce } from "lodash";

export default {
  name: "BookingServicePackagesList",
  components: { BookingServicePackagesListTable },
  data: () => ({
    loading: false,
    filter: { name: "", limit: 10 },
    headers: [
      { text: "Name", value: "name" },
      { text: "Zuletzt geändert am", value: "updatedAt" },
      { text: "Aktionen", sortable: false, value: "actions" }
    ]
  }),
  async mounted() {
    this.isLoading = true;
    const itemsPerPage = this.itemsPerPage;
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.filter.limit = itemsPerPage;
      this.filter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    await this.$store.dispatch("getServicePackages", this.filter);
    await this.$store.dispatch("getAccommodationTypes");
    await this.$store.dispatch("getBookingFeatures");
    await this.$store.dispatch("getAllUsers");
    this.isLoading = false;
  },
  methods: {
    setFilterPage(page) {
      this.filter.page = page;
    },
    setFilterLimit(limit) {
      this.filter.limit = limit;
      this.filter.itemsPerPage = limit;
      localStorage.setItem("itemsPerPage", limit);
    },
    async getServicePackages(filter) {
      await this.$store.dispatch("getServicePackages", filter);
    },
    applySearchText: debounce(async function() {
      if (this.filter.name.length >= 3 || !this.filter.name.length)
        await this.$store.dispatch("getServicePackages", this.filter);
    }, 500)
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    servicePackages() {
      return this.$store.state.servicePackages;
    },
    servicePackageCount() {
      return this.$store.state.servicePackageCount;
    },
    bookingFeatureGroups() {
      return this.$store.state.bookingFeatureGroups;
    },
    accommodationTypes() {
      return this.$store.state.accommodationTypes;
    }
  }
};
